import React from 'react';
import { FaSpinner, FaCheckCircle, FaTimesCircle, FaInfoCircle, FaClipboardCheck, FaSync, FaEdit } from 'react-icons/fa';

const TestValidationStatus = ({ 
  testData, 
  allTestsPassed, 
  isLoadingTests, 
  themeColor = 'emerald', 
  onRefresh,
  // Callback per aprire un test specifico in modifica
  onEditTest 
}) => {
  // Aggiungi il pulsante refresh in tutte le versioni del componente
  const RefreshButton = () => onRefresh ? (
    <button
      onClick={onRefresh}
      className={`ml-2 text-${themeColor}-500 hover:text-${themeColor}-700 dark:text-${themeColor}-400 dark:hover:text-${themeColor}-200 transition-colors`}
      title="Ricarica test"
    >
      <FaSync className="h-3 w-3" />
    </button>
  ) : null;

  if (isLoadingTests) {
    return (
      <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <FaSpinner className="animate-spin mr-2 h-4 w-4 text-blue-600 dark:text-blue-400" />
            <span className="text-sm text-blue-600 dark:text-blue-400">
              Caricamento test in corso...
            </span>
          </div>
          <RefreshButton />
        </div>
      </div>
    );
  }

  if (!testData || testData.length === 0) {
    return (
      <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-600 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <FaInfoCircle className="mr-2 h-4 w-4 text-gray-500 dark:text-gray-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Nessun test configurato per questa macro funzione
            </span>
          </div>
          <RefreshButton />
        </div>
      </div>
    );
  }

  const passedTests = testData.filter(test => test.TEM_TestSuperato === true || test.TEM_TestSuperato === 1);
  const failedTests = testData.filter(test => test.TEM_TestSuperato === false || test.TEM_TestSuperato === 0);

  if (allTestsPassed) {
    return (
      <div className={`mt-4 p-3 bg-${themeColor}-50 dark:bg-${themeColor}-900/20 border border-${themeColor}-200 dark:border-${themeColor}-800 rounded-lg`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <FaCheckCircle className={`mr-2 h-4 w-4 text-${themeColor}-600 dark:text-${themeColor}-400`} />
            <span className={`text-sm font-medium text-${themeColor}-700 dark:text-${themeColor}-300`}>
              Tutti i test sono superati
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <FaClipboardCheck className={`h-4 w-4 text-${themeColor}-600 dark:text-${themeColor}-400`} />
            <span className={`text-xs text-${themeColor}-600 dark:text-${themeColor}-400`}>
              {testData.length} test{testData.length !== 1 ? '' : ''}
            </span>
            <RefreshButton />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <FaTimesCircle className="mr-2 h-4 w-4 text-red-600 dark:text-red-400" />
          <span className="text-sm font-medium text-red-700 dark:text-red-300">
            Test non completati - Limitazioni attive
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <FaClipboardCheck className="h-4 w-4 text-red-600 dark:text-red-400" />
          <span className="text-xs text-red-600 dark:text-red-400">
            {passedTests.length}/{testData.length} superati
          </span>
          <RefreshButton />
        </div>
      </div>
      
      <div className="text-xs text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30 p-2 rounded border">
        <strong>Restrizione attiva:</strong> Non è possibile impostare MAC_Stato su "Terminata" o "Da rilasciare" 
        fino a quando tutti i test non sono superati.
      </div>

      {failedTests.length > 0 && (
        <div className="mt-2">
          <p className="text-xs font-medium text-red-700 dark:text-red-300 mb-2">
            Test da completare:
          </p>
          <div className="space-y-1">
            {failedTests.map((test, index) => (
              <div key={test.TEM_Id_TestModifiche || index} className="flex items-center justify-between bg-red-100 dark:bg-red-900/40 p-2 rounded border border-red-200 dark:border-red-700">
                <div className="flex items-start flex-1">
                  <FaTimesCircle className="mr-2 h-3 w-3 text-red-500 dark:text-red-400 mt-0.5 flex-shrink-0" />
                  <span className="text-xs text-red-700 dark:text-red-300 flex-1">
                    <strong>{test.TEM_DescrizioneModifica || `Test #${test.TEM_Id_TestModifiche}`}</strong>
                    {test.TEM_CriterioTest && (
                      <div className="text-red-600 dark:text-red-400 mt-1 text-xs">
                        Criterio: {test.TEM_CriterioTest}
                      </div>
                    )}
                  </span>
                </div>
                {/* Link/Pulsante per aprire il test in modifica */}
                {onEditTest && (
                  <button
                    onClick={() => {

                      onEditTest(test.TEM_Id_TestModifiche);
                    }}
                    className="ml-2 px-2 py-1 bg-blue-500 hover:bg-blue-600 text-white text-xs rounded transition-colors flex items-center"
                    title={`Modifica test: ${test.TEM_DescrizioneModifica || 'Test'}`}
                  >
                    <FaEdit className="h-3 w-3 mr-1" />
                    Modifica
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TestValidationStatus;